module.exports = __webpack_public_path__ + "img/vertical_4_5_5.64d66a42.png";